import "./Podium.css";
import { backendUrl } from "../../../constants";

const Podium = ({ rankingList }) => {

  return (
    <div className="podium-container">
      {/* Podium Image */}
      <img src="assets/img/podium.png" alt="Podium" className="podium-image" />

      {/* User Images */}
      {rankingList?.map((user, index) => (
        <div
          key={index}
          className={`podium-user rank-${index + 1}`}
        >
          <img src={user?.profilePic ? backendUrl + user?.profilePic?.filename : "assets/img/Frame1.svg"} alt={user.first_name} className="user-img" />
        </div>
      ))}
    </div>
  );
};

export default Podium;
